var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "shelvery-service" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "transition-group",
              { attrs: { name: "list", appear: "" } },
              _vm._l(_vm.accountsSorted, function(account) {
                return _c("div", { key: account.id }, [
                  _c(
                    "a",
                    {
                      staticClass: "account card",
                      class: [
                        _vm.accountSelected(account) ? "selected" : "unselected"
                      ],
                      on: {
                        click: function($event) {
                          return _vm.updateAccount(account)
                        }
                      }
                    },
                    [
                      _c("h5", [_vm._v(_vm._s(account.name))]),
                      _vm._v(" "),
                      _vm.accountSelected(account)
                        ? _c("span", { staticClass: "timestamp" }, [
                            _vm._v(
                              _vm._s(
                                _vm.lastUpdate(_vm.shelveryReport, _vm.loading)
                              )
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              }),
              0
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "column" }, [
          _vm.shelveryReportSorted.resources
            ? _c(
                "div",
                [
                  _c(
                    "transition-group",
                    { attrs: { name: "list", appear: "" } },
                    _vm._l(_vm.shelveryReportSorted.resources, function(
                      resource,
                      index
                    ) {
                      return _c("div", { key: resource.resource.arn }, [
                        _c(
                          "a",
                          {
                            staticClass: "resources card",
                            class: [
                              { enabled: _vm.shelveryEnabled(resource.config) },
                              {
                                disabled: _vm.shelveryDisabled(resource.config)
                              },
                              {
                                notConfigured: !_vm.shelveryConfigured(
                                  resource.config
                                )
                              },
                              _vm.resourceSelected(resource)
                                ? "selected"
                                : "unselected"
                            ],
                            on: {
                              click: function($event) {
                                _vm.resourceIndex = index
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.resourceName(resource.resource)) +
                                "\n            "
                            )
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column details" }, [
          _vm.shelveryReportSorted.resources &&
          _vm.shelveryReportSorted.resources.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "transition-group",
                    { attrs: { name: "fade", appear: "" } },
                    _vm._l(
                      [_vm.shelveryReportSorted.resources[_vm.resourceIndex]],
                      function(resource) {
                        return _c("div", { key: resource.resource.arn }, [
                          resource.config
                            ? _c("div", { staticClass: "card" }, [
                                _c("h4", { staticClass: "details" }, [
                                  _vm._v("resource details")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "dl",
                                  { staticClass: "details-dl" },
                                  [
                                    _vm._l(resource.resource, function(
                                      value,
                                      key
                                    ) {
                                      return [
                                        _c("dt", { key: key }, [
                                          _vm._v(_vm._s(key))
                                        ]),
                                        _c("dd", { key: key }, [
                                          _vm._v(_vm._s(value))
                                        ])
                                      ]
                                    })
                                  ],
                                  2
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          Object.entries(resource.config).length !== 0
                            ? _c("div", { staticClass: "card" }, [
                                _c("h4", { staticClass: "config" }, [
                                  _vm._v("shelvery config")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "dl",
                                  { staticClass: "config-dl" },
                                  [
                                    _vm._l(resource.config, function(v, k) {
                                      return [
                                        _c(
                                          "dt",
                                          {
                                            key: k,
                                            class: [
                                              _vm.validConfigKey(k)
                                                ? "validKey"
                                                : "invalidKey"
                                            ]
                                          },
                                          [_vm._v(_vm._s(k))]
                                        ),
                                        _c("dd", { key: k + v }, [
                                          _vm._v(_vm._s(v))
                                        ])
                                      ]
                                    })
                                  ],
                                  2
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          Object.entries(resource.snapshots).length !== 0
                            ? _c(
                                "div",
                                { staticClass: "card" },
                                [
                                  _c("h4", [_vm._v("shelvery snapshots")]),
                                  _vm._v(" "),
                                  _vm._l(resource.snapshots, function(
                                    snapshots,
                                    type
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: type,
                                        staticClass:
                                          "list-group list-group-flush"
                                      },
                                      [
                                        _c("h6", [_vm._v(_vm._s(type))]),
                                        _vm._v(" "),
                                        _vm._l(snapshots, function(
                                          snapshot,
                                          index
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key:
                                                snapshot.date_created +
                                                "-" +
                                                index,
                                              staticClass: "list-group-item"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(snapshot.name) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        ])
                      }
                    ),
                    0
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41e8f099", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e8f099","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ShelveryService.vue
// module id = null
// module chunks = 